"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplyAndCancelButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _excluded = ["onApply", "onCancel", "applyButtonProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    bottomButtonsWrapper: {
      padding: "1rem"
    }
  };
});
var ApplyAndCancelButtons = function ApplyAndCancelButtons(_ref) {
  var onApply = _ref.onApply,
    onCancel = _ref.onCancel,
    applyButtonProps = _ref.applyButtonProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, _extends({
    className: classes.bottomButtonsWrapper,
    container: true,
    justifyContent: "space-between",
    wrap: "nowrap"
  }, props), /*#__PURE__*/_react.default.createElement(_core.Button, {
    size: "small",
    onClick: onCancel,
    variant: "text"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "columns_Cancel",
    defaultMessage: "columns_Cancel"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    size: "small",
    color: "primary",
    onClick: onApply,
    variant: "contained"
  }, applyButtonProps), /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "columns_Apply",
    defaultMessage: "columns_Apply"
  })));
};
exports.ApplyAndCancelButtons = ApplyAndCancelButtons;